import React from "react"

const ListItem = ({ children }) => {
  return <li className=" mb-3">{children}</li>
}

export default ListItem
